import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.report');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-page-report',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.report/view.scss */
/* src/app/page.report/view.scss: no such file or directory */`],
})
export class PageReportComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default PageReportComponent;